import multipleChecksProps from "@wielink-application/shared/js/mixins/multipleChecksProps.js";
export default multipleChecksProps;
